<template>
  <div class="card basket-card">
    <div class="card-body">
      <div class="text">
        <div class="btnclose" @click="toggle(index)">
          <base-icon icon_name="edit" class="m-3" />
        </div>

        <h6 class="card-title ml-3 mt-3">{{ item.title }}</h6>
        <h6 class="ml-3 mt-3">
          {{  (item.total_price) | exchange_rate_left }} - {{ $t("qty") }}:
          {{ item.qty }}
        </h6>
        <template v-for="op in item.options">
          <h6 :key="op.option_id" class="ml-3">
            {{ op.title }} :
            <template v-for="opl in op.optionvalues">
              <span :key="opl.opion_value_id" class="ttle-dec">{{
                opl.title
              }}</span>
            </template>
          </h6>
        </template>

        <p class="ml-3 mb-3" v-if="item.note && !collape">
          {{ $t("note") }} : {{ item.note }}
        </p>

        <div class="m-3" v-if="collape"> 
          <input type="text" class="form-control" :placeholder="$t('Note')" v-model="item.note" >
        </div>
        

      </div>
      <div class="price mr-3"></div>
      <div class="action-buttom" v-if="collape">
        <button
          type="button"
          @click="remove()"
          class="btn btn-text btn-sm btn-action"
        >
          <base-icon icon_name="trash-2" />
        </button>
        <button
          type="button"
          class="btn btn-circle btn-sm btn-action float-right"
          @click="plus()"
        >
          <base-icon icon_name="plus" />
        </button>

        <button
          type="button"
          class="btn btn-circle btn-sm btn-action float-right"
          @click="munius()"
        >
          <base-icon icon_name="minus" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
export default {
  name: "basketCard",
  props: {
    item: Object,
    index: Number,
  },
  data: () => ({
    collape: false,
  }),
  computed: {
    selected_currency() {
      return store.getters["currency/selected_currency"];
    },
  },
  methods: {
    toggle() {
      this.collape = !this.collape;
    },
    remove() {
      this.$store.dispatch("order/removeItem", this.item);
    },
    plus() {
      this.$store.dispatch("order/adjustItem", {
        plus: true,
        key_id: this.item.key_id,
      });
    },
    munius() {
      this.$store.dispatch("order/adjustItem", {
        plus: false,
        key_id: this.item.key_id,
      });
    },  
  },
};
</script>
 